import { render } from "./IconExternalLink.vue?vue&type=template&id=e0bcbe7c"
import script from "./IconExternalLink.vue?vue&type=script&lang=js"
export * from "./IconExternalLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__